import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Address } from '@chargify/address';
import { Button } from '@chargify/custom-ui-components';
import { ShippingAddressModel } from '../../models/customerDetails/types';

export type ShippingAddressFormProps = {
  shippingAddress: ShippingAddressModel;
  onSubmit: (values: ShippingAddressModel) => void;
  onCancel: () => void;
  isSaving: boolean;
};

export const US_FORMAT_ADDRESS_FORM = ['US'];

const ShippingAddressForm = ({
  shippingAddress,
  onSubmit,
  onCancel,
  isSaving,
}: ShippingAddressFormProps) => {
  const { t } = useTranslation('customer-details');
  const [address, setAddress] = useState(shippingAddress);
  return (
    <>
      <Address
        values={address}
        requiredFields={[]}
        format={
          US_FORMAT_ADDRESS_FORM.includes(address.country)
            ? 'us'
            : 'international'
        }
        onChange={(fieldName: string, value) => {
          setAddress((prevState) => ({
            ...prevState,
            [fieldName]: value,
          }));
        }}
      />
      <Button.Group>
        <Button
          label={t('shipping_address.update_shipping_address')}
          color={'primary'}
          onClick={() => onSubmit(address)}
          isLoading={isSaving}
        />
        <Button
          label={t('cancel', {
            ns: 'common',
          })}
          color={'secondary'}
          onClick={onCancel}
        />
      </Button.Group>
    </>
  );
};

export default ShippingAddressForm;
